import React, { Component } from 'react'
import $ from 'jquery'
const config = require('../Config/Config')
export default class Logout extends Component {
    componentDidMount() {
        $.ajax({
            method: "post",
            url: config.SapService.logoutUrl,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: (data) => {
                console.log(data);
                if (!data.Success)
                    window.location.replace("/" + this.props.loginUrl)
            },
            error: (xhr, status, err) => {
                console.error("ajax hata", status, err.toString());
            }
        });
    }
    render() {
        return (
            <div>

            </div>
        )
    }
}
